import { BusinessDayComponent } from 'app/calendar/business-day/business-day.component';
import { WelcomeComponent } from 'app/home/welcome/welcome';
import { HomeComponent } from './home/home';
import { SalaAttesaComponent } from 'app/calendar/sala-attesa/sala_attesa';
import { LoginComponent } from 'app/login/login';

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RubricaComponent } from 'app/rubrica/rubrica';
import { AnagraficaComponent } from 'app/anagrafica/anagrafica';
import {BlankComponent} from "./home/blank/blank.component";

const routes: Routes = [
	{
		path: 'login',
		component: LoginComponent
	},
	{
		path: 'agende/:codice_fiscale/:agenda',
		component: HomeComponent,
		children: [
			{
				path: 'orario',
				component: BusinessDayComponent
			},
			{
				path: 'waiting',
				component: SalaAttesaComponent
			},
			{
				path: 'anagrafica',
				component: AnagraficaComponent
			}
		]
	},
	{
		path: 'rubrica',
		component: HomeComponent,
		children: [
			{
				path: '',
				component: RubricaComponent
			}
		]
	},
	{
		path: 'agende',
		component: HomeComponent,
		children: [
			{
				path: '',
				component: WelcomeComponent
			}
		]
	},
  {
    'path': 'blank',
    component: BlankComponent,

  },
	{
		path: '**',
		redirectTo: 'agende'
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts